module.exports = "<svg id=\"99c1c590-bc7a-43e4-901d-864fac8f111b\" data-name=\"Layer 2\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1271 187.06\"><title>patient-top-blue</title><path d=\"M.1.68c446.19-5,1145.06,141.38,1270.4,186.5H.1Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/patient-top-blue.svg
// module id = 567
// module chunks = 1